import { Box, Button, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { memo } from 'react'
import { DownloadTableExcel } from 'react-export-table-to-excel';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import SettingsIcon from '@mui/icons-material/Settings';

function ExportContent({ title, ExcelExportFileName, onFullScreen, filterContent, onChangeValueOF1, onChangeValueOF2, ValueOf1, ValueOf2, onRefreshData, onSettingHandler, excelTableRef, onGenPdf }) {
    // console.log('ExportContent')
    console.log("excelTableRef", excelTableRef);
console.log("excelTableRef.current", excelTableRef?.current);
    const { palette, spacing, shape: { borderRadius } } = useTheme()
    // const mds = useMediaQuery(useTheme().breakpoints.down('lg'))
    const smd2 = useMediaQuery(useTheme().breakpoints.down('md'))
    const styles = {
        IconStyle: {
            color: 'primary.main',
            fontSize: '0.9rem',
            cursor: 'pointer'

        }
    }
    return (
        <Stack direction={'row'} p={spacing(1)} component={Paper} justifyContent={'space-between'} alignItems={'center'}>
            <Typography variant='body1'>{title}</Typography>
            <Stack direction={'row'} sx={{ flexDirection: smd2 ? 'row-reverse' : 'row' }} alignItems={"center"} columnGap={spacing(1)}>
                <Box flex={1}>
                    {
                        filterContent ? filterContent : null
                    }
                </Box>
                <Box sx={{ flex: 1, display: 'flex', columnGap: spacing(1), justifyContent: 'space-around', alignItems: "center" }}>

                    {/* <DownloadTableExcel
                        filename={ExcelExportFileName ? ExcelExportFileName : "Unknown"}
                        sheet="users"
                        currentTableRef={excelTableRef}
                    >
                        <Button variant='contained' size={'small'} sx={{ color: 'background.default', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.blue, borderRadius: borderRadius }}>Excel</Button>
                    </DownloadTableExcel> */}

                    <DownloadTableExcel
                        filename={ExcelExportFileName ? ExcelExportFileName : "Unknown"}
                        sheet="users"
                        currentTableRef={excelTableRef.current ? excelTableRef.current : null} 
                    >
                        <Button variant='contained' size='small' sx={{ color: 'background.default', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.blue, borderRadius: borderRadius }}>
                            Excel
                        </Button>
                    </DownloadTableExcel>

                

                    {/* <Button onClick={excelTableRef} variant='contained' size='small' sx={{ color: 'background.default', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.blue, borderRadius: borderRadius }}>
                            Excel
                        </Button> */}

                    <Button onClick={onGenPdf} variant='contained' sx={{ color: 'background.default', p: 0, m: 0, fontSize: '12px', backgroundColor: 'error.main', borderRadius: borderRadius }}>PDF</Button>

                    <FullscreenIcon sx={styles.IconStyle} onClick={onFullScreen} color='primary' />
                </Box>
            </Stack>
        </Stack>
    )
}

export default memo(ExportContent)
